import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';

import { AuthService } from './authentication/auth.service';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
    constructor(private authService: AuthService) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        var cleSession = this.authService.getCleSession();
        if (cleSession && cleSession != "") {
            request = request.clone({
                setHeaders: {
                    ContentType:  'application/json',
                    Authorization: "Basic " + btoa(`${cleSession}:`)
                }
            });
        }

        return next.handle(request);
    }
}
